import { createElement } from 'react';
import { GroupHeaderItemProps } from '.';
import cx from 'classnames';
import { renderInlineCssVars } from '../../../theme';
import { Heading } from '../../Heading';
import cn from './GroupHeaderItem.css.json';
import './GroupHeaderItem.css';

/**
 * The GroupHeaderItem component that renders the group header element.
 *
 * <b>Note:</b> The GroupHeaderItem is meant to use either a ListProps's
 * `renderItem` or ListColumnProps's `item`, which will display
 * at the body of the item.
 *
 * @component
 * @param {GroupHeaderItemProps} props the GroupHeaderItemProps properties
 * @returns the Item element
 */
export const GroupHeaderItem = (props: GroupHeaderItemProps) => {
  const tokens = renderInlineCssVars({ fg: props.tokens?.fg }, 'list-group-header');
  const itemContent = (
    <Heading
      disabled={props.disabled}
      level={6}
      title={props.tooltip}
      style={{ ...tokens, ...props.style }}
      className={cx(cn.groupItemText, props.className)}
      data-testid={props.testId}
    >
      {props.title}
    </Heading>
  );
  return itemContent;
};
